import styled from 'styled-components';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const SelectorField = styled.div`
  width: 700px;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  gap: ${SPACERS.tiny};
  flex-direction: column;
  margin: ${SPACERS.medium} auto 0 auto;
`;

export default SelectorField;
